import { render, staticRenderFns } from "./training-pro.vue?vue&type=template&id=62da3dac&scoped=true&"
import script from "./training-pro.vue?vue&type=script&lang=js&"
export * from "./training-pro.vue?vue&type=script&lang=js&"
import style0 from "./training-pro.vue?vue&type=style&index=0&id=62da3dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62da3dac",
  null
  
)

export default component.exports